/* Manages app configuration data in the client side */
angular.module('config', [])
    .factory('credentialsInterceptor', ['tgConfig', function (tgConfig) {
        return {
            request: function (config) {
                function normalizeDomain(url) {
                    if (!url) return "";
                    return url.replace(/^http(s)?:\/\//, '').replace(/\/.*$/, '');
                }

                const rootUrl = normalizeDomain(tgConfig?.rootUrl);
                const backendUrl = normalizeDomain(tgConfig?.backendUrl);

                if (
                    config.url.includes(rootUrl) ||
                    config.url.includes(backendUrl)
                ) {
                    config.withCredentials = true;
                } else {
                    config.withCredentials = false;
                }
                return config;
            }
        };
    }])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('credentialsInterceptor');
    }]);
